import { Slides } from "./slides";
import Image from "next/legacy/image";
import { Tag } from "./tag";
import { ScrollView } from "../UI/ScrollView";
import { useTranslation } from "next-i18next";
import CupPointIcon from "../../public/img/mall/cup-point.svg";
import Button from "../UI/Button";
import classnames from "classnames";
import { formatThousand } from "utils";
import { translate } from "utils/i18n";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import { LimitReasonEnum } from "@/constants/mall";
import { useEffect, useState } from "react";
import { goodsLimitApi } from "@/utils/api";

export const ItemModalItem = ({
  item,
  title,
  desc,
  isHolder,
  onRedeem,
  cupPointsInfo,
}) => {
  const { t } = useTranslation("mall");
  const router = useRouter();

  const [goodsLimitInfo, setGoodsLimitInfo] = useState<{
    isSuccess;
    limitReason;
  }>();

  const init = async () => {
    const res = await goodsLimitApi({ goodsId: item.goodsId });
    console.log("goodsLimitApi", res);
    setGoodsLimitInfo(res?.data);
  };

  const timeLimit =
    +item.limitTime <= 0 ? undefined : dayjs(item.limitTime * 1000);

  const renderBtn = () => {
    let disabledText;

    if (item.onlyHolder && !isHolder) {
      disabledText = t("btnHolder");
    } else if (+cupPointsInfo?.total < item.cupPoints) {
      disabledText = t("btnPoints");
    } else if (
      goodsLimitInfo?.limitReason === LimitReasonEnum.LIMIT_REASON_REDEEMED
    ) {
      disabledText = t("btnRedeemed");
    } else if (
      goodsLimitInfo?.limitReason ===
      LimitReasonEnum.LIMIT_REASON_REDEEMED_NATURAL_MONTH
    ) {
      disabledText = t("btnRedeemedMonth");
    }  else if (
      goodsLimitInfo?.limitReason ===
      LimitReasonEnum.LIMIT_REASON_REDEEMED_NATURAL_DAY
    ) {
      disabledText = t("btnRedeemedDay");
    } else if (+item.goodsStat.total === 0) {
      disabledText = t("btnStock");
    }

    if (disabledText) {
      return (
        <button
          className="h-full w-full btn-unstyled rounded-full flex justify-center items-center align-middle px-[20px] bg-[#f1f2f3] text-[#C9CCD0] cursor-not-allowed text-[18px] font-black"
          disabled
        >
          {disabledText}
        </button>
      );
    }

    return (
      <Button
        variant="contained"
        color="secondary"
        component="span"
        className={classnames(
          "w-full h-full rounded-full transition font-black text-[18px]",
          "text-white hover:opacity-80"
        )}
        onClick={onRedeem}
      >
        <span>{t("btnRedeem")}</span>
      </Button>
    );
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div
      className="flex items-center w-[1100px] py-[24px] pl-[56px] pr-[60px] bg-white"
      style={{ backgroundColor: item.backgroundColor || "#AEB3B9" }}
    >
      <div className="w-[500px] h-[500px] mr-[64px] ">
        <Slides list={[item.mainPic, ...item.multiPic].filter((s) => !!s)} />
      </div>

      <div className="flex-1 relative">
        <div className="text-[40px] leading-[47px] font-bold font-DIN_Alternate mb-[10px] relative">
          <div className="absolute top-[-28px] left-[-52px] w-[206px] h-[91px]">
            <Image src="/img/mall/line-bg.png" layout="fill" />
          </div>

          <div className="relative">{title}</div>
        </div>

        <div className="relative">
          <div className="min-h-[1px]">
            {item.showStorageLabel && (
              <Tag>
                {+item.goodsStat.total === 0
                  ? t("soldout")
                  : translate(t("itemCount"), { count: item.goodsStat.total })}
              </Tag>
            )}

            {timeLimit && (
              <Tag>
                {translate(t("itemTimeLimit"), {
                  time:
                    router.locale === "cn"
                      ? timeLimit.format("YYYY.MM.DD")
                      : timeLimit.format("MMMM DD, YYYY"),
                })}
              </Tag>
            )}
          </div>

          <div
            className="text-[16px] leading-[24px] font-normal whitespace-pre-wrap mt-[14px]"
            dangerouslySetInnerHTML={{ __html: desc }}
          ></div>
        </div>

        <div className="mt-[40px] flex justify-between items-center pb-[16px] mb-[24px] border-0 border-solid border-b border-[rgba(0,0,0,0.2)]">
          <div className="text-[14px] font-medium">{t("cuppoints")}</div>
          <div className="flex items-center text-[20px] font-black">
            <CupPointIcon />
            <span>{formatThousand(item.cupPoints)}</span>
          </div>
        </div>

        <div className="h-[56px] text-[18px] font-black">{renderBtn()}</div>
      </div>
    </div>
  );
};
